import React from "react";



import "./MLHLink.css"


function MLHLink(){
   
    return(
        <div class="mlhlink-container">
           <a class="ui orange button" href="https://github.com/MLH/mlh-policies/blob/main/code-of-conduct.md" target="_blank" rel="noopener noreferrer">
                MLH Code of Conduct
            </a>
        </div>
    )
}

export default MLHLink